import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
	customTableCell: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	skeletonRow: {
		"& td": {
			padding: "12px 16px",
			borderBottom: theme.palette.type === "dark"
				? "1px solid rgba(255,255,255,0.04)"
				: "1px solid #F1F5F9",
		},
	},
}));

const TableRowSkeleton = ({ avatar, columns }) => {
	const classes = useStyles();
	return (
		<>
			<TableRow className={classes.skeletonRow}>
				{avatar && (
					<>
						<TableCell style={{ paddingRight: 0 }}>
							<Skeleton
								animation="wave"
								variant="circle"
								width={40}
								height={40}
								style={{ borderRadius: 8 }}
							/>
						</TableCell>
						<TableCell>
							<Skeleton
								animation="wave"
								height={30}
								width={80}
								style={{ borderRadius: 8 }}
							/>
						</TableCell>
					</>
				)}
				{Array.from({ length: columns }, (_, index) => (
					<TableCell align="center" key={index}>
						<div className={classes.customTableCell}>
							<Skeleton
								align="center"
								animation="wave"
								height={30}
								width={80}
								style={{ borderRadius: 8 }}
							/>
						</div>
					</TableCell>
				))}
			</TableRow>
		</>
	);
};

export default TableRowSkeleton;
